const TYPE_ID = 'globalpedia_pc_v2';
/**
 * （页面）打点公共基础参数
 */
const BASE_PAGE_PARAMS = {
  logType: 'pageLog',
  openId: '', // 每次请求时会动态去获取
  pageLog: {
    pageId: '', // 页面唯一标识
    pageName: '', // 页面名称
    pagePath: '', // 页面路径
    source: 0,
    extInfo: '', // 填游戏id，没有不填（选填）
    typeId: TYPE_ID,
    isOnline: 'logIn',
    uidType: '', // 标记id记号（选填）
    uid: '', // 是某个游戏页面时传游戏id（选填）
  },
};

/** 注意：键名不要以_SUBMIT或_SEARCH结尾，避免和按钮/搜索打点冲突 */
const ALL_PAGE_STATIC_REPORT_OPERATION_LOG: {
  [keyName: string]: {
    pageId: string;
    pageName: string;
    pagePath: string;
  };
} = {
  // Dashboard页面
  PIPELINE_DASHBOARD: {
    pageId: '500101',
    pageName: 'Pipeline-Overview',
    pagePath: '/g-pop/Pipeline/Overview',
  },
  // All Projects页面
  PIPELINE_PROJECT_LIST: {
    pageId: '500201',
    pageName: 'Pipeline-ProjectList',
    pagePath: '/g-pop/Pipeline/ProjectList',
  },
  // 游戏详情页面
  PIPELINE_DETAIL: {
    pageId: '500301',
    pageName: 'Pipeline-ProjectDetail',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 游戏详情Milestone页签
  PIPELINE_DETAIL_MILESTONE: {
    pageId: '502601',
    pageName: 'Pipeline-ProjectDetail-Milestone',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Project Update页签Update Info
  PIPELINE_DETAIL_PROJECT_UPDATE: {
    pageId: '500401',
    pageName: 'Pipeline-ProjectDetail-ProjectUpdate',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Project Update页签Full Action Items List
  PIPELINE_DETAIL_PROJECT_UPDATE_ACTION_LIST: {
    pageId: '500402',
    pageName: 'Pipeline-ProjectDetail-ProjectUpdate-ActionItemsList',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Stakeholder页签
  PIPELINE_DETAIL_STAKEHOLDER: {
    pageId: '500501',
    pageName: 'Pipeline-ProjectDetail-Stakeholder',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Performance页签
  PIPELINE_DETAIL_KPI_PERFORMANCE: {
    pageId: '500601',
    pageName: 'Pipeline-ProjectDetail-KPIPerformance',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Finance页签
  PIPELINE_DETAIL_FINANCE: {
    pageId: '500701',
    pageName: 'Pipeline-ProjectDetail-Finance',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 详情页Technical页签
  PIPELINE_DETAIL_TECHNICAL: {
    pageId: '503101',
    pageName: 'Pipeline-ProjectDetail-Technical',
    pagePath: '/g-pop/Pipeline/ProjectList/Detail',
  },
  // 工作台新增游戏页面
  WORKSPACE_ADD_PRODUCT: {
    pageId: '500801',
    pageName: 'MyWorkspace-AddNewProduct',
    pagePath: '/g-pop/Workspace/AddProduct',
  },

  /** * Studio Overall预览页 ***/
  STUDIO_OVERALL_OVERVIEW: {
    pageId: '500901',
    pageName: 'Studio-PortfolioOverview-Overview',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_CALENDAR: {
    pageId: '501001',
    pageName: 'Studio-PortfolioOverview-Calendar',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_PROJECTS_LIVE: {
    pageId: '501101',
    pageName: 'Studio-PortfolioOverview-Projects-Live',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_PROJECTS_DEV: {
    pageId: '501102',
    pageName: 'Studio-PortfolioOverview-Projects-Development',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_FINANCE_OVERVIEW: {
    pageId: '501201',
    pageName: 'Studio-PortfolioOverview-Finance-Overview',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_FINANCE_FORECAST: {
    pageId: '501202',
    pageName: 'Studio-PortfolioOverview-Finance-5YearForecast',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_PEOPLE: {
    pageId: '501301',
    pageName: 'Studio-PortfolioOverview-People',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_MANAGEMENT_KEY_ISSUES: {
    pageId: '501401',
    pageName: 'Studio-PortfolioOverview-Management-KeyIssues',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  STUDIO_OVERALL_MANAGEMENT_BOARD_GOVERNANCE: {
    pageId: '501402',
    pageName: 'Studio-PortfolioOverview-Management-BoardGovernance',
    pagePath: '/g-pop/Studio/PortfolioOverview',
  },
  /** * Studio Overall预览页 ***/

  /** * Studio Overall详情页 ***/
  STUDIO_OVERALL_DETAILS_OVERVIEW: {
    pageId: '501501',
    pageName: 'Studio-PortfolioOverview-Detail-Overview',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_CALENDAR: {
    pageId: '501601',
    pageName: 'Studio-PortfolioOverview-Detail-Calendar',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_PROJECTS_LIVE: {
    pageId: '501701',
    pageName: 'Studio-PortfolioOverview-Detail-Projects-Live',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_PROJECTS_DEVELOPMENT: {
    pageId: '501702',
    pageName: 'Studio-PortfolioOverview-Detail-Projects-Development',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_FINANCE: {
    pageId: '501801',
    pageName: 'Studio-PortfolioOverview-Detail-Finance',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_PEOPLE: {
    pageId: '501901',
    pageName: 'Studio-PortfolioOverview-Detail-People',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_MANAGEMENT_KEY_ISSUES: {
    pageId: '502001',
    pageName: 'Studio-PortfolioOverview-Detail-Management-KeyIssues',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  STUDIO_OVERALL_DETAILS_MANAGEMENT_BOARD_GOVERNANCE: {
    pageId: '502002',
    pageName: 'Studio-PortfolioOverview-Detail-Management-BoardGovernance',
    pagePath: '/g-pop/Studio/PortfolioOverview/Detail',
  },
  /** * Studio Overall详情页 ***/

  // Studio Business Metrics页面
  STUDIO_BUSINESS_METRICS: {
    pageId: '502101',
    pageName: 'Studio-MetricsDashboard',
    pagePath: '/g-pop/Studio/MetricsDashboard',
  },
  STUDIO_MONTHLY_REPORT_PERFORMANCE_OVERVIEW: {
    pageId: '502201',
    pageName: 'MonthlyReport-PerformanceOverview',
    pagePath: '/g-pop/MonthlyReport/PerformanceOverview',
  },
  STUDIO_MONTHLY_REPORT_GROSS_REVENUE_TRENDS: {
    pageId: '502301',
    pageName: 'MonthlyReport-GrossRevenueTrends',
    pagePath: '/g-pop/MonthlyReport/GrossRevenueTrends',
  },
  STUDIO_MONTHLY_REPORT_LIVE_TITLE: {
    pageId: '502401',
    pageName: 'MonthlyReport-LiveTitle',
    pagePath: '/g-pop/MonthlyReport/LiveTitle',
  },
  STUDIO_MONTHLY_REPORT_IN_DEVELOPMENT: {
    pageId: '502501',
    pageName: 'MonthlyReport-InDevTitle',
    pagePath: '/g-pop/MonthlyReport/InDevTitle',
  },
  /** *** Workspace目录下的页面 *** **/
  // DPSReport页面（DPS周报页面）
  WORKSPACE_DPS_WEEKLY_REPORT: {
    pageId: '502701',
    pageName: 'Pipeline-DPSReport',
    pagePath: '/g-pop/Pipeline/DPSNewsletter',
  },
  // DPSReport页面（DPS周报新增页面）
  WORKSPACE_DPS_WEEKLY_REPORT_ADD: {
    pageId: '502702',
    pageName: 'Pipeline-AddDPSReport',
    pagePath: '/g-pop/Pipeline/DPSNewsletter/AddReport',
  },
  // DPSReport页面（DPS周报编辑页面）
  WORKSPACE_DPS_WEEKLY_REPORT_EDIT: {
    pageId: '502703',
    pageName: 'Pipeline-EditDPSReport',
    pagePath: '/g-pop/Pipeline/DPSNewsletter/EditReport',
  },
  /** *** Workspace目录下的页面 *** **/
  // GR Action Items页面
  PIPELINE_GR_ACTION_ITEMS: {
    pageId: '502801',
    pageName: 'Pipeline-GRActionItems',
    pagePath: '/g-pop/Pipeline/GRActionItems',
  },

  // Metrics指标说明页
  METRICS: {
    pageId: '502901',
    pageName: 'Metrics',
    pagePath: '/g-pop/Metrics',
  },

  // Pipeline / Change Log / Change Detail页面
  PIPELINE_CHANGE_LOG_CHANGE_DETAIL: {
    pageId: '503001',
    pageName: 'ChangeLog-ChangeDetail',
    pagePath: '/g-pop/Pipeline/ChangeLog/ChangeDetail',
  },
  // Pipeline / Change Log / Change Checklist页面
  PIPELINE_CHANGE_LOG_CHANGE_CHECKLIST: {
    pageId: '503002',
    pageName: 'ChangeLog-ChangeChecklist',
    pagePath: '/g-pop/Pipeline/ChangeLog/ChangeChecklist',
  },

  /** 文档预览页 **/
  // Milestone附件预览页
  MILESTONE_DOC_PREVIEWER: {
    pageId: '509901',
    pageName: 'DocPreviewer-MilestoneDocPreviewer',
    pagePath: '/g-pop/DocPreviewer',
  },
  // Updates附件预览页
  UPDATES_DOC_PREVIEWER: {
    pageId: '509902',
    pageName: 'DocPreviewer-UpdatesDocPreviewer',
    pagePath: '/g-pop/DocPreviewer',
  },
  // DPS Report（v3的Memo Pending Approval模块的memo附件）附件预览页
  DPS_REPORT_MEMO_DOC_PREVIEWER: {
    pageId: '509903',
    pageName: 'DocPreviewer-DPSReportMemoDocPreviewer',
    pagePath: '/g-pop/DocPreviewer',
  },
  // Overview附件预览页
  OVERVIEW_DOC_PREVIEWER: {
    pageId: '509904',
    pageName: 'DocPreviewer-OverviewDocPreviewer',
    pagePath: '/g-pop/DocPreviewer',
  },
  /** 文档预览页 **/
};

/**
 * （搜索）打点公共基础参数
 */
const BASE_SEARCH_PARAMS = {
  logType: 'searchLog',
  openId: '', // 每次请求时会动态去获取
  searchLog: {
    // searchId: '', // 搜索位置唯一标识
    // pageId: '', // 与页面pageId对应上
    query: '', // 搜索内容
    clickId: '', // 搜索的游戏id，没有不填（选填）
    source: 1,
    extInfo: '', // 填游戏名或页面pageId，没有不填（选填）
    typeId: TYPE_ID,
    uidType: '', // 标记id记号（选填）
    uid: '', // 是某个游戏页面时传游戏id（选填）
  },
};

/** 注意：键名_SEARCH结尾 */
const ALL_SEARCH_REPORT_OPERATION_LOG: {
  [keyName: string]: {
    extInfo: string;
    uidType: string;
    uid: string;
  };
} = {
  /* 'ALL_PROJECTS_SEARCH': {
    // searchId: '',
    // pageId: '',
    query: '',
  }, */
  METRICS_SEARCH: {
    extInfo: '502901',
    uidType: '',
    uid: '',
  },
};

/**
 * （按钮）打点公共基础参数
 */
const BASE_BUTTON_PARAMS = {
  logType: 'buttonLog',
  openId: '', // 每次请求时会动态去获取
  buttonLog: {
    buttonId: '', // 按钮唯一标识
    pageId: '', // 与页面pageId对应上
    source: 1,
    extInfo: '', // 文档没说（不填）
    typeId: TYPE_ID,
    // uidType: '', // 标记id记号（没有）
    // uid: '', // 是某个游戏页面时传游戏id（没有）
  },
};

/** 注意：键名_SUBMIT结尾 */
const ALL_BUTTON_REPORT_OPERATION_LOG: {
  [keyName: string]: {
    buttonId: string;
    pageId: string;
  };
} = {
  // Dashboard页面Schedule模块excel下载
  PIPELINE_DASHBOARD_SCHEDULE_EXCEL_SUBMIT: {
    buttonId: '500101001',
    pageId: '500101',
  },
  // Dashboard页面Schedule模块csv下载
  PIPELINE_DASHBOARD_SCHEDULE_CSV_SUBMIT: {
    buttonId: '500101002',
    pageId: '500101',
  },
  // Dashboard页面Schedule模块切换到日历
  PIPELINE_DASHBOARD_SCHEDULE_CALENDAR_SUBMIT: {
    buttonId: '500101003',
    pageId: '500101',
  },
  // Dashboard页面Schedule模块切换到月历
  PIPELINE_DASHBOARD_SCHEDULE_TABLE_SUBMIT: {
    buttonId: '500101004',
    pageId: '500101',
  },
  // Dashboard页面Schedule模块Time Change按钮点击
  PIPELINE_DASHBOARD_SCHEDULE_TIME_CHANGE: {
    buttonId: '500101005',
    pageId: '500101',
  },
  // All Projects页面CSV下载
  ALL_PROJECTS_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500201001',
    pageId: '500201',
  },
  // All Projects页面EXCEL下载
  ALL_PROJECTS_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500201002',
    pageId: '500201',
  },
  // All Projects页面列表编辑
  ALL_PROJECTS_EDIT_SUBMIT: {
    buttonId: '500201003',
    pageId: '500201',
  },

  // 产品详情页Milestone页签新增卡片
  DETAIL_MILESTONE_ADD_SUBMIT: {
    buttonId: '502601001',
    pageId: '502601',
  },
  // 产品详情页Milestone页签编辑卡片
  DETAIL_MILESTONE_EDIT_SUBMIT: {
    buttonId: '502601002',
    pageId: '502601',
  },
  // 产品详情页Milestone页签删除卡片
  DETAIL_MILESTONE_DELETE_SUBMIT: {
    buttonId: '502601003',
    pageId: '502601',
  },
  // 产品详情页Milestone GR附件下载
  DETAIL_MILESTONE_GR_DOCUMENT_DOWNLOAD_SUBMIT: {
    buttonId: '502601004',
    pageId: '502601',
  },
  // 产品详情页Milestone GR附件预览
  DETAIL_MILESTONE_GR_DOCUMENT_PREVIEW_SUBMIT: {
    buttonId: '502601009',
    pageId: '502601',
  },
  // 产品详情页Milestone GR附件分享
  DETAIL_MILESTONE_GR_DOCUMENT_SHARE_SUBMIT: {
    buttonId: '502601010',
    pageId: '502601',
  },
  // 产品详情页Milestone页签Update Info模块csv下载
  DETAIL_MILESTONE_INFO_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502601005',
    pageId: '502601',
  },
  // 产品详情页Milestone页签设置Next Milestone
  DETAIL_MILESTONE_INFO_SETTING_NEXT_MILESTONE_SUBMIT: {
    buttonId: '502601006',
    pageId: '502601',
  },
  // 产品详情页Milestone页签展开所有Milestone
  DETAIL_MILESTONE_INFO_EXPAND_ALL_MILESTONES: {
    buttonId: '502601007',
    pageId: '502601',
  },
  // 产品详情页Milestone页签折叠所有Milestone
  DETAIL_MILESTONE_INFO_FOLD_ALL_MILESTONES: {
    buttonId: '502601008',
    pageId: '502601',
  },

  // 产品详情页Project Update页签新增卡片
  DETAIL_PROJECT_UPDATE_ADD_SUBMIT: {
    buttonId: '500401001',
    pageId: '500401',
  },
  // 产品详情页Project Update页签编辑卡片
  DETAIL_PROJECT_UPDATE_EDIT_SUBMIT: {
    buttonId: '500401002',
    pageId: '500401',
  },
  // 产品详情页Project Update页签删除卡片
  DETAIL_PROJECT_UPDATE_DELETE_SUBMIT: {
    buttonId: '500401003',
    pageId: '500401',
  },
  // 产品详情页Project Update页签Update Info模块csv下载
  DETAIL_PROJECT_UPDATE_INFO_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500401004',
    pageId: '500401',
  },
  // 产品详情页Project Update页签Update Info模块excel下载
  DETAIL_PROJECT_UPDATE_INFO_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500401005',
    pageId: '500401',
  },
  // 产品详情页Project Update页签附件预览
  DETAIL_UPDATES_GR_DOCUMENT_PREVIEW_SUBMIT: {
    buttonId: '500401006',
    pageId: '500401',
  },
  // 产品详情页Project Update页签附件下载
  DETAIL_UPDATES_GR_DOCUMENT_DOWNLOAD_SUBMIT: {
    buttonId: '500401007',
    pageId: '500401',
  },
  // 产品详情页Project Update页签附件分享
  DETAIL_UPDATES_GR_DOCUMENT_SHARE_SUBMIT: {
    buttonId: '500401008',
    pageId: '500401',
  },
  // 产品详情页Project Overview页签附件预览
  DETAIL_OVERVIEW_DOCUMENT_PREVIEW_SUBMIT: {
    buttonId: '500401009',
    pageId: '500403',
  },
  // 产品详情页Project Overview页签附件下载
  DETAIL_OVERVIEW_DOCUMENT_DOWNLOAD_SUBMIT: {
    buttonId: '500401010',
    pageId: '500403',
  },
  // 产品详情页Project Overview页签附件分享
  DETAIL_OVERVIEW_DOCUMENT_SHARE_SUBMIT: {
    buttonId: '500401011',
    pageId: '500403',
  },
  // 产品详情页Project Update页签Full Action Items List模块csv下载
  DETAIL_PROJECT_UPDATE_ACTION_LIST_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500402001',
    pageId: '500402',
  },
  // 产品详情页Project Update页签Full Action Items List模块excel下载
  DETAIL_PROJECT_UPDATE_ACTION_LIST_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500402002',
    pageId: '500402',
  },
  // 产品详情页Project Detail页签Production Milestone列表下载
  DETAIL_PROJECT_DETAIL_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500301001',
    pageId: '500301',
  },
  // 产品详情页Project Detail页签Production Milestone列表附件下载
  DETAIL_PROJECT_DETAIL_PRODUCTION_MILESTONE_FILE_DOWNLOAD_SUBMIT: {
    buttonId: '500301002',
    pageId: '500301',
  },
  // 产品详情页Project 头部Overview编辑
  DETAIL_PROJECT_DETAIL_OVERVIEW_EDIT_SUBMIT: {
    buttonId: '500301003',
    pageId: '500301',
  },
  // 产品详情页Project Game Information模块编辑
  DETAIL_PROJECT_DETAIL_GAME_INFORMATION_EDIT_SUBMIT: {
    buttonId: '500301004',
    pageId: '500301',
  },
  // 产品详情页Project Visual Showcase模块编辑
  DETAIL_PROJECT_DETAIL_VISUAL_SHOWCASE_EDIT_SUBMIT: {
    buttonId: '500301005',
    pageId: '500301',
  },
  // 产品详情页Project Similar Games模块编辑
  DETAIL_PROJECT_DETAIL_SIMILAR_GAMES_EDIT_SUBMIT: {
    buttonId: '500301006',
    pageId: '500301',
  },
  // 产品详情页Project切换Project
  DETAIL_PROJECT_DETAIL_SWITCH_PROJECT_SUBMIT: {
    buttonId: '500301099',
    pageId: '500301',
  },
  // 产品详情页Finance页签Total Budget Breakdown下载
  DETAIL_FINANCE_TOTAL_BUDGET_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701001',
    pageId: '500701',
  },
  // 产品详情页Finance页签Spend to Date Breakdown下载
  DETAIL_FINANCE_SPEND_TO_DATE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701002',
    pageId: '500701',
  },
  // 产品详情页Finance页签Budget Trend下载
  DETAIL_FINANCE_BUDGET_TREND_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701003',
    pageId: '500701',
  },
  // 产品详情页Finance页签Headcount下载
  DETAIL_FINANCE_HEADCOUNT_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701004',
    pageId: '500701',
  },
  // 产品详情页Finance页签Forecast 3-Year Revenue & ROI & Profit%下载
  DETAIL_FINANCE_FORECAST_YEAR_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701005',
    pageId: '500701',
  },
  // 产品详情页Finance页签Data Change History下载
  DETAIL_FINANCE_DATA_CHANGE_HISTORY_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701006',
    pageId: '500701',
  },
  // 产品详情页Finance页签Budget Trend模块Add Event
  DETAIL_FINANCE_BUDGET_TREND_ADD_EVENT_SUBMIT: {
    buttonId: '500701007',
    pageId: '500701',
  },
  // 产品详情页Finance页签Headcount模块Add Event
  DETAIL_FINANCE_HEADCOUNT_ADD_EVENT_SUBMIT: {
    buttonId: '500701008',
    pageId: '500701',
  },
  // 产品详情页Finance页签Forecast 3-Year Revenue & ROI & Profit%模块Add Event
  DETAIL_FINANCE_FORECAST_YEAR_ADD_EVENT_SUBMIT: {
    buttonId: '500701009',
    pageId: '500701',
  },
  // 产品详情页Finance页签Dev Cost By Month模块下载CSV
  DETAIL_FINANCE_DEV_COST_BY_MONTH_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500701010',
    pageId: '500701',
  },
  // 产品详情页Finance页签Development Budget Change模块Approved Total Development Budget页签下载EXCEL
  DETAIL_FINANCE_DEV_BUDGET_CHANGE_APPROVED_TOTAL_DEV_BUDGET_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500701013',
    pageId: '500701',
  },
  // 产品详情页Finance页签Development Budget Change模块Milestone Approved Budget and Cost页签下载EXCEL
  DETAIL_FINANCE_DEV_BUDGET_CHANGE_MILESTONE_APPROVED_BUDGET_COST_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500701015',
    pageId: '500701',
  },
  // 产品详情页Performance页签Overall下载
  DETAIL_PERFORMANCE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500601001',
    pageId: '500601',
  },
  // 产品详情页Stakeholder页签编辑
  DETAIL_STAKEHOLDER_IEGG_EDIT_SUBMIT: {
    buttonId: '500501001',
    pageId: '500501',
  },
  // 产品新增页编辑内容提交
  ADD_PRODUCT_SUBMIT: {
    buttonId: '500801001',
    pageId: '500801',
  },
  // Studio Overall预览页 Directory of Portfolio Studios CSV下载
  STUDIO_OVERALL_OVERVIEW_DIRECTORY_OF_PORTFOLIO_STUDIOS_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '500901001',
    pageId: '500901',
  },
  // Studio Overall预览页 Directory of Portfolio Studios EXCEL下载
  STUDIO_OVERALL_OVERVIEW_DIRECTORY_OF_PORTFOLIO_STUDIOS_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '500901002',
    pageId: '500901',
  },
  // Studio Overall预览页 搜索-删除搜索记录按钮打点
  STUDIO_OVERALL_OVERVIEW_DELATE_SEARCH_RECENT: {
    buttonId: '500901003',
    pageId: '500901',
  },
  // Studio Overall页面 Finance 页签Overview中Gross Revenue卡片excel下载
  STUDIO_OVERALL_FINANCE_OVERVIEW_GROSS_REVENUE_EXCEL_SUBMIT: {
    buttonId: '501201001',
    pageId: '501201',
  },
  // Studio Overall页面 Finance 页签Overview中Gross Revenue卡片csv下载
  STUDIO_OVERALL_FINANCE_OVERVIEW_GROSS_REVENUE_CSV_SUBMIT: {
    buttonId: '501201002',
    pageId: '501201',
  },
  // Studio Overall页面 Finance 页签Overview中Net Profit卡片excel下载
  STUDIO_OVERALL_FINANCE_OVERVIEW_NET_PROFIT_EXCEL_SUBMIT: {
    buttonId: '501201003',
    pageId: '501201',
  },
  // Studio Overall页面 Finance 页签Overview中Net Profit卡片csv下载
  STUDIO_OVERALL_FINANCE_OVERVIEW_NET_PROFIT_CSV_SUBMIT: {
    buttonId: '501201004',
    pageId: '501201',
  },
  // Studio Overall页面 Finance 页签5-Year Forecast中Base Scenario卡片excel下载
  STUDIO_OVERALL_FINANCE_FORECAST_BASE_SCENARIO_EXCEL_SUBMIT: {
    buttonId: '501202001',
    pageId: '501202',
  },
  // Studio Overall页面 Finance 页签5-Year Forecast中Base Scenario卡片csv下载
  STUDIO_OVERALL_FINANCE_FORECAST_BASE_SCENARIO_CSV_SUBMIT: {
    buttonId: '501202002',
    pageId: '501202',
  },
  // Studio Overall页面 Finance 页签5-Year Forecast中Conservative Scenario卡片excel下载
  STUDIO_OVERALL_FINANCE_FORECAST_CONSERVATIVE_SCENARIO_EXCEL_SUBMIT: {
    buttonId: '501202003',
    pageId: '501202',
  },
  // Studio Overall页面 Finance 页签5-Year Forecast中Conservative Scenario卡片csv下载
  STUDIO_OVERALL_FINANCE_FORECAST_CONSERVATIVE_SCENARIO_CSV_SUBMIT: {
    buttonId: '501202004',
    pageId: '501202',
  },
  // Studio Overall页面People页签Headcounts excel下载
  STUDIO_OVERALL_PEOPLE_HEADCOUNTS_EXCEL_SUBMIT: {
    buttonId: '501301001',
    pageId: '501301',
  },
  // Studio Overall页面People页签Headcounts csv下载
  STUDIO_OVERALL_PEOPLE_HEADCOUNTS_CSV_SUBMIT: {
    buttonId: '501301002',
    pageId: '501301',
  },
  // Studio Overall页面People页签Headcount Cost excel下载
  STUDIO_OVERALL_PEOPLE_HEADCOUNT_COST_EXCEL_SUBMIT: {
    buttonId: '501301003',
    pageId: '501301',
  },
  // Studio Overall页面People页签Headcount Cost csv下载
  STUDIO_OVERALL_PEOPLE_HEADCOUNT_COST_CSV_SUBMIT: {
    buttonId: '501301004',
    pageId: '501301',
  },
  // Studio Overall页面People页签5Y Headcounts excel下载
  STUDIO_OVERALL_PEOPLE_5Y_HEADCOUNTS_EXCEL_SUBMIT: {
    buttonId: '501301005',
    pageId: '501301',
  },
  // Studio Overall页面People页签5Y Headcounts csv下载
  STUDIO_OVERALL_PEOPLE_5Y_HEADCOUNTS_CSV_SUBMIT: {
    buttonId: '501301006',
    pageId: '501301',
  },
  // Studio Overall页面Projects页签Development页签Budget Spend Trends模块csv下载
  STUDIO_OVERALL_PROJECTS_DEV_BUDGET_SPEND_TRENDS_CSV_SUBMIT: {
    buttonId: '501102001',
    pageId: '501102',
  },
  // Studio Overall页面Projects页签Development页签Budget Spend Trends模块excel下载
  STUDIO_OVERALL_PROJECTS_DEV_BUDGET_SPEND_TRENDS_EXCEL_SUBMIT: {
    buttonId: '501102002',
    pageId: '501102',
  },
  // Studio Overall详情页Projects页签Total Revenue Trends模块csv下载
  STUDIO_OVERALL_DETAIL_PROJECTS_TOTAL_REVENUE_TRENDS_CSV_SUBMIT: {
    buttonId: '501701001',
    pageId: '501701',
  },
  // Studio Overall详情页Projects页签Total Revenue Trends模块excel下载
  STUDIO_OVERALL_DETAIL_PROJECTS_TOTAL_REVENUE_TRENDS_EXCEL_SUBMIT: {
    buttonId: '501701002',
    pageId: '501701',
  },
  // Studio Overall详情页Projects页签Breakdown模块csv下载
  STUDIO_OVERALL_DETAIL_PROJECTS_BREAKDOWN_CSV_SUBMIT: {
    buttonId: '501701003',
    pageId: '501701',
  },
  // Studio Overall详情页Projects页签Breakdown模块excel下载
  STUDIO_OVERALL_DETAIL_PROJECTS_BREAKDOWN_EXCEL_SUBMIT: {
    buttonId: '501701004',
    pageId: '501701',
  },
  // Studio Overall详情页Projects页签Overview模块csv下载
  STUDIO_OVERALL_DETAIL_PROJECTS_OVERVIEW_CSV_SUBMIT: {
    buttonId: '501702001',
    pageId: '501702',
  },
  // Studio Overall详情页Projects页签Overview模块excel下载
  STUDIO_OVERALL_DETAIL_PROJECTS_OVERVIEW_EXCEL_SUBMIT: {
    buttonId: '501702002',
    pageId: '501702',
  },
  // Studio Overall详情页Projects页签Cost模块csv下载
  STUDIO_OVERALL_DETAIL_PROJECTS_COST_CSV_SUBMIT: {
    buttonId: '501702003',
    pageId: '501702',
  },
  // Studio Overall详情页Projects页签Cost模块excel下载
  STUDIO_OVERALL_DETAIL_PROJECTS_COST_EXCEL_SUBMIT: {
    buttonId: '501702004',
    pageId: '501702',
  },
  // Studio Overall详情页People页签Headcounts CSV下载
  STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNTS_CSV_SUBMIT: {
    buttonId: '501901001',
    pageId: '501901',
  },
  // Studio Overall详情页People页签Headcounts PDF下载
  STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNTS_PDF_SUBMIT: {
    buttonId: '501901002',
    pageId: '501901',
  },
  // Studio Overall详情页People页签Headcount Cost CSV下载
  STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNT_COST_CSV_SUBMIT: {
    buttonId: '501901003',
    pageId: '501901',
  },
  // Studio Overall详情页People页签Headcount Cost PDF下载
  STUDIO_OVERALL_DETAIL_PEOPLE_HEADCOUNT_COST_PDF_SUBMIT: {
    buttonId: '501901004',
    pageId: '501901',
  },
  // Studio Overall详情页People页签5Y Headcounts CSV下载
  STUDIO_OVERALL_DETAIL_PEOPLE_5Y_HEADCOUNTS_CSV_SUBMIT: {
    buttonId: '501901005',
    pageId: '501901',
  },
  // Studio Overall详情页People页签5Y Headcounts PDF下载
  STUDIO_OVERALL_DETAIL_PEOPLE_5Y_HEADCOUNTS_PDF_SUBMIT: {
    buttonId: '501901006',
    pageId: '501901',
  },
  // Studio Overall详情页Finance页签Revenue Completion模块 CSV下载
  STUDIO_OVERALL_DETAIL_FINANCE_REVENUE_COMPLETION_CSV_SUBMIT: {
    buttonId: '501801001',
    pageId: '501801',
  },
  // Studio Overall详情页Finance页签Revenue Completion模块 PDF下载
  STUDIO_OVERALL_DETAIL_FINANCE_REVENUE_COMPLETION_PDF_SUBMIT: {
    buttonId: '501801002',
    pageId: '501801',
  },
  // Studio Overall详情页Finance页签Profit Completion模块 CSV下载
  STUDIO_OVERALL_DETAIL_FINANCE_PROFIT_COMPLETION_CSV_SUBMIT: {
    buttonId: '501801003',
    pageId: '501801',
  },
  // Studio Overall详情页Finance页签Profit Completion模块 PDF下载
  STUDIO_OVERALL_DETAIL_FINANCE_PROFIT_COMPLETION_PDF_SUBMIT: {
    buttonId: '501801004',
    pageId: '501801',
  },
  // Studio Overall详情页Finance页签Middle - Long Time Financials模块 CSV下载
  STUDIO_OVERALL_DETAIL_FINANCE_MIDDLE_LONG_TIME_FINANCIALS_CSV_SUBMIT: {
    buttonId: '501801005',
    pageId: '501801',
  },
  // Studio Overall详情页Finance页签Middle - Long Time Financials模块 PDF下载
  STUDIO_OVERALL_DETAIL_FINANCE_MIDDLE_LONG_TIME_FINANCIALS_PDF_SUBMIT: {
    buttonId: '501801006',
    pageId: '501801',
  },
  // Performance Overview页面Studio Monthly Performance模块csv下载
  STUDIO_MONTHLY_REPORT_PERFORMANCE_OVERVIEW_STUDIO_PERFORMANCE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502201001',
    pageId: '502201',
  },
  // Performance Overview页面Studio Monthly Performance模块excel下载
  STUDIO_MONTHLY_REPORT_PERFORMANCE_OVERVIEW_STUDIO_PERFORMANCE_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502201002',
    pageId: '502201',
  },
  // Performance Overview页面Project Monthly Performance模块csv下载
  STUDIO_MONTHLY_REPORT_PERFORMANCE_OVERVIEW_PROJECT_PERFORMANCE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502201003',
    pageId: '502201',
  },
  // Performance Overview页面Project Monthly Performance模块excel下载
  STUDIO_MONTHLY_REPORT_PERFORMANCE_OVERVIEW_PROJECT_PERFORMANCE_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502201004',
    pageId: '502201',
  },
  // Gross Revenue Trends页面Studio Gross Revenue模块csv下载
  STUDIO_MONTHLY_REPORT_GROSS_REVENUE_TRENDS_STUDIO_GROSS_REVENUE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502301001',
    pageId: '502301',
  },
  // Gross Revenue Trends页面Studio Gross Revenue模块excel下载
  STUDIO_MONTHLY_REPORT_GROSS_REVENUE_TRENDS_STUDIO_GROSS_REVENUE_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502301002',
    pageId: '502301',
  },
  // Gross Revenue Trends页面Project Gross Revenue模块csv下载
  STUDIO_MONTHLY_REPORT_GROSS_REVENUE_TRENDS_PROJECT_GROSS_REVENUE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502301003',
    pageId: '502301',
  },
  // Gross Revenue Trends页面Project Gross Revenue模块excel下载
  STUDIO_MONTHLY_REPORT_GROSS_REVENUE_TRENDS_PROJECT_GROSS_REVENUE_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502301004',
    pageId: '502301',
  },
  // Live Title页面csv下载
  STUDIO_MONTHLY_REPORT_LIVE_TITLE_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502401001',
    pageId: '502401',
  },
  // Live Title页面excel下载
  STUDIO_MONTHLY_REPORT_LIVE_TITLE_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502401002',
    pageId: '502401',
  },
  // In Development页面csv下载
  STUDIO_MONTHLY_REPORT_IN_DEVELOPMENT_CSV_DOWNLOAD_SUBMIT: {
    buttonId: '502501001',
    pageId: '502501',
  },
  // In Development页面excel下载
  STUDIO_MONTHLY_REPORT_IN_DEVELOPMENT_EXCEL_DOWNLOAD_SUBMIT: {
    buttonId: '502501002',
    pageId: '502501',
  },
  /** *** Workspace目录下的页面 *** **/
  // DPSReport页面（DPS周报页面）删除周报
  WORKSPACE_DPS_WEEKLY_REPORT_DELETE_SUBMIT: {
    buttonId: '50270101',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）图片下载
  WORKSPACE_DPS_WEEKLY_REPORT_IMG_DOWNLOAD_SUBMIT: {
    buttonId: '50270102',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）PDF下载
  WORKSPACE_DPS_WEEKLY_REPORT_PDF_DOWNLOAD_SUBMIT: {
    buttonId: '50270103',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）发布
  WORKSPACE_DPS_WEEKLY_REPORT_PUBLISH_SUBMIT: {
    buttonId: '50270104',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）取消发布
  WORKSPACE_DPS_WEEKLY_REPORT_UNPUBLISH_SUBMIT: {
    buttonId: '50270105',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）点击Memo on GPOP
  WORKSPACE_DPS_WEEKLY_REPORT_MEMO_SUBMIT: {
    buttonId: '50270106',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）发送邮件
  WORKSPACE_DPS_WEEKLY_REPORT_SEND_EMAIL_SUBMIT: {
    buttonId: '50270107',
    pageId: '502701',
  },
  // DPSReport页面（DPS周报页面）(从DPS周报邮件中点DPS周报图片进入GPOP系统)
  WORKSPACE_DPS_WEEKLY_REPORT_ACCESS_FROM_EMAIL_SUBMIT: {
    buttonId: '50270199',
    pageId: '502701',
  },
  // DPSReport新增页面（DPS周报新增页面）点击Confirm新增
  WORKSPACE_DPS_WEEKLY_REPORT_ADD_CONFIRM_SUBMIT: {
    buttonId: '50270201',
    pageId: '502702',
  },
  // DPSReport新增页面（DPS周报新增页面）点击Publish新增
  WORKSPACE_DPS_WEEKLY_REPORT_ADD_PUBLISH_SUBMIT: {
    buttonId: '50270202',
    pageId: '502702',
  },
  // DPSReport新增页面（DPS周报新增页面）hightlights模块数据刷新
  WORKSPACE_DPS_WEEKLY_REPORT_ADD_REFRESH_HIGHTLIGHTS_SUBMIT: {
    buttonId: '50270203',
    pageId: '502702',
  },
  // DPSReport新增页面（DPS周报新增页面）calendar模块数据刷新
  WORKSPACE_DPS_WEEKLY_REPORT_ADD_REFRESH_CALENDAR_SUBMIT: {
    buttonId: '50270204',
    pageId: '502702',
  },
  // DPSReport新增页面（DPS周报新增页面）点击Confirm新增
  WORKSPACE_DPS_WEEKLY_REPORT_EDIT_CONFIRM_SUBMIT: {
    buttonId: '50270301',
    pageId: '502703',
  },
  // DPSReport新增页面（DPS周报新增页面）点击Publish新增
  WORKSPACE_DPS_WEEKLY_REPORT_EDIT_PUBLISH_SUBMIT: {
    buttonId: '50270302',
    pageId: '502703',
  },
  // DPSReport编辑页面（DPS周报编辑页面）hightlights模块数据刷新
  WORKSPACE_DPS_WEEKLY_REPORT_EDIT_REFRESH_HIGHTLIGHTS_SUBMIT: {
    buttonId: '50270303',
    pageId: '502703',
  },
  // DPSReport编辑页面（DPS周报编辑页面）calendar模块数据刷新
  WORKSPACE_DPS_WEEKLY_REPORT_EDIT_REFRESH_CALENDAR_SUBMIT: {
    buttonId: '50270304',
    pageId: '502703',
  },
  // GR Action Items页面 下载CSV
  PIPELINE_GR_ACTION_ITEMS_DOWNLOAD_CSV_SUBMIT: {
    buttonId: '50280101',
    pageId: '502801',
  },
  // GR Action Items页面 下载EXCEL
  PIPELINE_GR_ACTION_ITEMS_DOWNLOAD_EXCEL_SUBMIT: {
    buttonId: '50280102',
    pageId: '502801',
  },
  // GR Action Items页面 编辑GR Action Items
  PIPELINE_GR_ACTION_ITEMS_EDIT_SUBMIT: {
    buttonId: '50280103',
    pageId: '502801',
  },
  /** *** Workspace目录下的页面 *** **/
  /** Metrics指标说明页 **/
  METRICS_DELETE_SEARCH_SUBMIT: {
    buttonId: '50290101',
    pageId: '502901',
  },
  /** Metrics指标说明页 **/

  // Pipeline / Change Log / Change Detail页面 下载CSV
  PIPELINE_CHANGE_LOG_CHANGE_DETAIL_DOWNLOAD_CSV_SUBMIT: {
    buttonId: '50300101',
    pageId: '503001',
  },
  // Pipeline / Change Log / Change Detail页面 下载EXCEL
  PIPELINE_CHANGE_LOG_CHANGE_DETAIL_DOWNLOAD_EXCEL_SUBMIT: {
    buttonId: '50300102',
    pageId: '503001',
  },
  // Pipeline / Change Log / Change Checklist页面 下载CSV
  PIPELINE_CHANGE_LOG_CHANGE_CHECKLIST_DOWNLOAD_CSV_SUBMIT: {
    buttonId: '50300201',
    pageId: '503002',
  },
  // Pipeline / Change Log / Change Checklist页面 下载EXCEL
  PIPELINE_CHANGE_LOG_CHANGE_CHECKLIST_DOWNLOAD_EXCEL_SUBMIT: {
    buttonId: '50300202',
    pageId: '503002',
  },
  // 详情页Technical页签编辑
  PIPELINE_DETAIL_TECHNICAL_EDIT_SUBMIT: {
    buttonId: '50310101',
    pageId: '503101',
  },
};

/**
 * 打点接口映射使用
 */
export const OPERATION_LOG_MAP = {
  page: BASE_PAGE_PARAMS,
  button: BASE_BUTTON_PARAMS,
  search: BASE_SEARCH_PARAMS,
};

export const ALL_REPORT_OPERATION_LOG = {
  ...ALL_PAGE_STATIC_REPORT_OPERATION_LOG,
  ...ALL_BUTTON_REPORT_OPERATION_LOG,
  ...ALL_SEARCH_REPORT_OPERATION_LOG,
};
